import React from "react";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Game, { PHASER_GAMES } from "./Game";
import GameService from "../api/services/GameService";
import "./GameScreen.scss";
import useWindowDimensions from "../hooks/useWindowDimensions";
import { useDispatch } from "react-redux";
import Topbar from "./Topbar";
import { removeToken, setToken } from "../store/actions/setToken.action";
import SessionService from "../api/services/SessionService";

const GameScreen = () => {
  const { width } = useWindowDimensions();
  const dispatch = useDispatch();

  const location = useLocation();
  const aid = new URLSearchParams(location.search).get("aid");

  useEffect(() => {
    if (aid) {
      dispatch(setToken(aid));
      SessionService.set("token", aid);
    } else dispatch(removeToken());
  }, [dispatch, aid]);

  const [game, setGame] = useState(null),
    [gameRef, setGameRef] = useState(null),
    [start, setStart] = useState(null),
    [background, setBackground] = useState(null),
    [fullScreen, setFullScreen] = useState(false),
    params = useParams(),
    navigate = useNavigate(),
    initGame = useCallback(
      (type) => {
        setGameRef(null);
        (async () => {
          if (start === null) {
            let response = await GameService.initGameStatistics(
              params.slug,
              type
            );
            if (response.success) {
              setGameRef(response.data);
              setStart(new Date().toISOString());
              dispatch({ type: "RESET_ERROR" });
            } else {
              dispatch({ type: "SET_ERROR", payload: response.data });
            }
          }
        })();
      },
      [params.slug, start]
    ),
    endGame = (statistics) => {
      (async () => {
        const resp = await GameService.submitGameStatistics(
          gameRef,
          start,
          new Date().toISOString(),
          statistics.score,
          statistics.statistics
        );
        if (resp.success) {
          dispatch({ type: "DISPLAY_FEEDBACK_POPUP", payload: true });
        }
        setStart(null);
      })();
    };

  useEffect(() => {
    (async () => {
      let response = await GameService.getGame(params.slug);
      if (response.success) {
        let {
          background,
          type,
          intro = "",
          share = {},
          locked = false,
          game: payload = null,
        } = response.data;
        // if (locked) navigate("/games", { replace: true });
        setFullScreen(PHASER_GAMES.includes(type));
        setGame({ game: type, intro, share, payload });
        setGameRef(null);
        setBackground(background);
        dispatch({ type: "RESET_ERROR" });
      } else {
        dispatch({ type: "SET_ERROR", payload: response.data });
      }
    })();
  }, [params.slug]);

  useEffect(() => {
    if (width <= 1024 && fullScreen) {
      dispatch({ type: "IS_HIDE_TOPBAR", payload: true });
    }
    return () => {
      dispatch({ type: "IS_HIDE_TOPBAR", payload: false });
    };
  }, [dispatch, fullScreen, width]);

  const historyFallback = () => {
    let fallbackUrl = "/games";
    let prevPage = window.location.href;
    window.history.go(-1);
    setTimeout(function () {
      if (window.location.href === prevPage) {
        navigate(fallbackUrl);
        // window.location.href = fallbackUrl;
      }
    }, 500);
  };

  useEffect(() => {
    dispatch({ type: "SET_HEADER_TITLE_TEXT", payload: "" });
  }, []);

  return (
    <div
      className={fullScreen ? "" : "py-10 games-screen"}
      style={{
        "--desktop-image": `url(${background ? background.desktop : null})`,
        "--mobile-image": `url(${background ? background.mobile : null})`,
      }}
    >
      <style
        dangerouslySetInnerHTML={{
          __html: `
                  
          .bottom-nav-mobile{
            display: none;
          }
          
          .iwwjhm .dialog-content{
            top: calc(43%);
          }
                  @media(max-width: 599px){
                    .iwwjhm .dialog-content{
                      top: calc(48%);
                    }
                    .emotion-game{
                      padding-top: 5%;
                    }
                    .mobile-py-4{
                      padding-bottom: 0rem;
                      background: none;
                    }
                    @media(max-height: 680px){
                      .emotion-game{
                        padding-top: 5%;
                      }
                  }
                  
                    `,
        }}
      />
      <Topbar />
      {game && (
        <Game
          content={game}
          start={(type) => initGame(type)}
          end={(statistics) => endGame(statistics)}
          next={() => navigate("/games")}
          feature={"GAME"}
        />
      )}
    </div>
  );
};

export default GameScreen;
